import { makeStyles } from '@mui/styles';

export const usePricingRulesCustomersStyle = makeStyles(() => ({
  radioButton: {
    width: 100,
    minWidth: 100,
  },
}));
